import classes from './HomeSectionHead.module.scss';


// Общая шапка секции: крупный заголовок и кнопка справа.
const HomeSectionHead = ({ title, action, className = '' }) => (
  <div className={`${classes.head} ${className}`} data-aos="fade-up">
    <h2 className={classes.title}>{title}</h2>
    {action && <div className={classes.action}>{action}</div>}
  </div>
);

export default HomeSectionHead;
